/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetOrganizationWhitelistRequestBody,
  SetOrganizationWhitelistRequestBody$Outbound,
  SetOrganizationWhitelistRequestBody$outboundSchema,
} from "../components/setorganizationwhitelistrequestbody.js";

export type SetOrganizationWhitelistSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type SetOrganizationWhitelistRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  setOrganizationWhitelistRequestBody: SetOrganizationWhitelistRequestBody;
};

/** @internal */
export type SetOrganizationWhitelistSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const SetOrganizationWhitelistSecurity$outboundSchema: z.ZodMiniType<
  SetOrganizationWhitelistSecurity$Outbound,
  SetOrganizationWhitelistSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function setOrganizationWhitelistSecurityToJSON(
  setOrganizationWhitelistSecurity: SetOrganizationWhitelistSecurity,
): string {
  return JSON.stringify(
    SetOrganizationWhitelistSecurity$outboundSchema.parse(
      setOrganizationWhitelistSecurity,
    ),
  );
}

/** @internal */
export type SetOrganizationWhitelistRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  SetOrganizationWhitelistRequestBody:
    SetOrganizationWhitelistRequestBody$Outbound;
};

/** @internal */
export const SetOrganizationWhitelistRequest$outboundSchema: z.ZodMiniType<
  SetOrganizationWhitelistRequest$Outbound,
  SetOrganizationWhitelistRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    setOrganizationWhitelistRequestBody:
      SetOrganizationWhitelistRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      setOrganizationWhitelistRequestBody:
        "SetOrganizationWhitelistRequestBody",
    });
  }),
);

export function setOrganizationWhitelistRequestToJSON(
  setOrganizationWhitelistRequest: SetOrganizationWhitelistRequest,
): string {
  return JSON.stringify(
    SetOrganizationWhitelistRequest$outboundSchema.parse(
      setOrganizationWhitelistRequest,
    ),
  );
}
